import React from 'react';

export const inputCls =
  'w-full border border-white/15 rounded px-3 py-2 text-sm text-white bg-[#140b22] placeholder:text-white/30 focus:border-civix-cyan focus:ring-1 focus:ring-civix-cyan/40 outline-none transition';
export const smallInputCls =
  'w-full border border-white/15 rounded px-3 py-1.5 text-xs text-white bg-[#140b22] placeholder:text-white/30 focus:border-civix-cyan outline-none transition';
export const checkCls =
  'rounded border-white/20 bg-[#140b22] text-civix-purple focus:ring-0 focus:ring-offset-0';
export const outlineBtnCls =
  'px-3 py-1 rounded border border-civix-purple text-civix-purpleSoft text-xs font-bold uppercase tracking-wider hover:bg-civix-purple/10 transition cursor-pointer';
export const keywordChipCls =
  'text-[10px] px-1.5 py-0.5 rounded bg-white/10 text-white/80 hover:bg-civix-purple hover:text-white transition font-mono';

export function SectionHeading({ title, children }) {
  return (
    <div>
      <div className="flex items-center justify-between">
        <h3 className="text-base font-semibold text-white">{title}</h3>
        {children}
      </div>
      <div className="h-px bg-white/10 mt-2" />
    </div>
  );
}

// SweetAlert-style confirmation dialog shared by the duration and delete flows.
export function ConfirmModal({
  open, title, children, cancelLabel = 'Close', confirmLabel, confirmClass = 'bg-rose-600 hover:bg-rose-700',
  busy = false, onCancel, onConfirm, testId,
}) {
  if (!open) return null;
  return (
    <div
      data-testid={testId}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
    >
      <div className="bg-[#140b22] rounded-xl shadow-2xl max-w-md w-full p-6 text-center space-y-4 border border-white/10">
        <div className="w-16 h-16 rounded-full border-4 border-amber-400 text-amber-400 mx-auto flex items-center justify-center font-bold text-3xl">
          !
        </div>
        <h3 className="text-xl font-bold text-white">{title}</h3>
        <p className="text-sm text-white/70">{children}</p>
        <div className="flex items-center justify-end gap-3 pt-3">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 rounded bg-white/10 hover:bg-white/15 text-white text-xs font-bold uppercase"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            disabled={busy}
            onClick={onConfirm}
            className={`px-4 py-2 rounded text-white text-xs font-bold uppercase disabled:opacity-50 ${confirmClass}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
